import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from "axios";
import {createBrowserRouter, Navigate, RouterProvider, useLocation} from "react-router-dom";
import LoginPage from "./pages/authentication/loginPage";
import ErrorPage from "./pages/errorPage";
import FindEvents from "./pages/events/findEvents";
import Dashboard from "./pages/dashboard/dashboard";
import NLPDashboard from "./pages/nlp/nlpdash";
import ViewArtist from "./pages/attractions/viewArtist";
import ViewEvent from "./pages/events/viewEvent";
import {Provider} from 'react-redux'
//import store from './redux/store'
import ImportDashboard from "./pages/import/importdash";
import {toast, ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import AdminEventsDashboard from "./pages/events/adminevents";
import Addscriptstosite from "./pages/documentation/addscriptstosite";
import Mediaiceland from "./pages/documentation/mediaiceland";
import Admarketiceland from "./pages/documentation/admarketiceland";
import Whatarewedoingforthemedia from "./pages/documentation/whatarewedoingforthemedia";
import Admarket from "./pages/admarket/admarket";
import Adminactions from "./pages/events/adminactions";
import {MetaTags} from "./components/common/utilities";
import {HelmetProvider} from "react-helmet-async";
import ViewVenue from "./pages/venues/viewVenue";
import MergeVenue from "./pages/venues/mergeVenue";
import ListVenues from "./pages/venues/listVenues";
import ListAttractions from "./pages/attractions/listAttractions";
import MergeAttractions from "./pages/attractions/mergeAttractions";
import NLPPrompt from "./pages/nlp/nlpprompt";
import AudienceDashboard from "./pages/dashboard/audiencedashboard";
import CreatePage from "./pages/authentication/createUser";
import VerifyEmailPage from "./pages/authentication/verifyEmail";
import SendResetLinkPage from "./pages/authentication/sendResetLinkj";
import NewPasswordPage from "./pages/authentication/resetPassword";
import UserDashboard from "./pages/dashboard/userdashboard";
import ListEvents from "./pages/events/listEvents";
import ViewInvite from "./pages/authentication/viewInvite";
import MergeEvents from "./pages/events/mergeEvents";
import Toplist from "./pages/statistics/toplist";
import MonthlyEvents from "./pages/events/monthlyevents";
import CreateEvent from "./pages/events/createEvent";
import CreateEvents from "./pages/events/createEvents";
import AdminImportDashboard from "./pages/import/adminimportdash";
import ListAdsOrdered from "./pages/events/listAdsOrdered";

import './i18n/i18n';
import DashboardWeek from "./pages/dashboard/dashboardweek";
import EventHistory from "./pages/events/eventHistory";
import Adminactionitems from "./pages/dashboard/adminactionitems";
import HowDoesItAllFitTogether from "./pages/publicpages/howdoesitallfittogether";
import MediaDashboard from "./pages/media/mediadashboard";

const loggedIn = false;

let pagename = "Backstage";

function RequireAuth({children}: { children: JSX.Element })
{
    let auth = false;
    if (localStorage.getItem('ticket') != null && localStorage.getItem('ticket') != '')
    {
        auth = true;
    }
    let location = useLocation();

    if (!auth)
    {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/loginuser" state={{from: location}} replace/>;
    }

    return children;
}

function NotAuth({children}: { children: JSX.Element })
{
    let auth = false;
    if (localStorage.getItem('ticket') != null && localStorage.getItem('ticket') != '')
    {
        auth = true;
    }
    let location = useLocation();

    if (auth)
    {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/dashboard" state={{from: location}} replace/>;
    }

    return children;
}

let gogoLocation = null;

function getUserLocation()
{
    axios.get(`https://data.promogogo.com/p/where.do`)
        .then(res => {
            gogoLocation = res.data;
            console.log(gogoLocation);
            return gogoLocation;
        })
}

const router = createBrowserRouter([{
    path: "/", element: <App/>, errorElement: <ErrorPage/>,

}, {
    path: "/dashboard",
    element: <RequireAuth><Dashboard/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);
            document.title = "Backstage Dashboard";
            /*try
            {
                JSON.parse(response.data);
            }
            catch (e)
            {
                localStorage.removeItem('ticket');
                window.location.href = '/loginuser';
            }*/

            // handle success
            //console.log(response);
            let location = response.data;
            return location;


        }).catch(function (error) {
            console.log('error', error);
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        });
    },
}, {
    path: "/dashboard/week",
    element: <RequireAuth><DashboardWeek/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);
            document.title = "Backstage Dashboard";
            /*try
            {
                JSON.parse(response.data);
            }
            catch (e)
            {
                localStorage.removeItem('ticket');
                window.location.href = '/loginuser';
            }*/

            // handle success
            //console.log(response);
            let location = response.data;
            return location;


        }).catch(function (error) {
            console.log('error', error);
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        });
    },
},{
    path: "/mediadashboard",
    element: <RequireAuth><MediaDashboard/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);
            document.title = "Backstage Dashboard";
            let location = response.data;
            return location;


        }).catch(function (error) {
            console.log('error', error);
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        });
    },
}, {
    path: "/manage/user",
    element: <RequireAuth><UserDashboard/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);
            document.title = "Backstage Dashboard";
            /*try
            {
                JSON.parse(response.data);
            }
            catch (e)
            {
                localStorage.removeItem('ticket');
                window.location.href = '/loginuser';
            }*/

            // handle success
            //console.log(response);
            let location = response.data;
            return location;


        }).catch(function (error) {
            console.log('error', error);
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        });
    },
}, {
    path: "/invite/:token", element: <ViewInvite/>, errorElement: <ErrorPage/>, loader: async ({params}) => {
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/viewinvite.do`, {
            token: params.token,
        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded'
                              }
                          }).then(function (response) {
            // handle success
            //console.log(response);
            let location = response.data;
            return location;

        });
    },
}, {
    path: "/dashboard/audience",
    element: <RequireAuth><AudienceDashboard/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);
            document.title = "Backstage Dashboard";
            /*try
            {
                JSON.parse(response.data);
            }
            catch (e)
            {
                localStorage.removeItem('ticket');
                window.location.href = '/loginuser';
            }*/

            // handle success
            //console.log(response);
            let location = response.data;
            return location;


        }).catch(function (error) {
            console.log('error', error);
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        });
    },
}, {
    path: "/nlpdash",
    element: <RequireAuth><NLPDashboard/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);
            /*try
            {
                JSON.parse(response.data);
            }
            catch (e)
            {
                localStorage.removeItem('ticket');
                window.location.href = '/loginuser';
            }*/

            // handle success
            //console.log(response);
            let location = response.data;
            return location;


        }).catch(function (error) {
            console.log('error', error);
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        });
    },
}, {
    path: "/import",
    element: <RequireAuth><ImportDashboard/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);
            /*try
            {
                JSON.parse(response.data);
            }
            catch (e)
            {
                localStorage.removeItem('ticket');
                window.location.href = '/loginuser';
            }*/

            // handle success
            //console.log(response);
            let location = response.data;
            return location;


        });
    },
}, {
    path: "/ads/listads",
    element: <RequireAuth><ListAdsOrdered/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);
            /*try
            {
                JSON.parse(response.data);
            }
            catch (e)
            {
                localStorage.removeItem('ticket');
                window.location.href = '/loginuser';
            }*/

            // handle success
            //console.log(response);
            let location = response.data;
            return location;


        });
    },
}, {
    path: "/admin/import",
    element: <RequireAuth><AdminImportDashboard/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);
            /*try
            {
                JSON.parse(response.data);
            }
            catch (e)
            {
                localStorage.removeItem('ticket');
                window.location.href = '/loginuser';
            }*/

            // handle success
            //console.log(response);
            let location = response.data;
            return location;


        });
    },
}, {
    path: "/adminevents",
    element: <RequireAuth><AdminEventsDashboard/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);
            /*try
            {
                JSON.parse(response.data);
            }
            catch (e)
            {
                localStorage.removeItem('ticket');
                window.location.href = '/loginuser';
            }*/

            // handle success
            //console.log(response);
            let location = response.data;
            return location;


        });
    },
}, {
    path: "/admin/actions",
    element: <RequireAuth><Adminactions/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            let location = response.data;
            return location;


        });
    },
}, {
    path: "/admin/actionitems",
    element: <RequireAuth><Adminactionitems/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/monthlyevents",
    element: <RequireAuth><MonthlyEvents/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/admarket",
    element: <RequireAuth><Admarket/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);
            document.title = "Backstage Dashboard";
            let location = response.data;
            return location;


        }).catch(function (error) {
            console.log('error', error);
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        });
    },
}, {
    path: "/view/:mask/:id",
    element: <RequireAuth><ViewArtist/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.get(`${process.env.REACT_APP_API_URL}/p/api/artist.do?`, {
            params: {
                tiny: true, artist: params.id,
            },

        }).then(function (response) {
            // handle success
            //console.log(response);
            let location = response.data;
            return location;

        });
    },
}, {
    path: "/edit/:mask/:id",
    element: <RequireAuth><ViewArtist/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        if (params.mask == 'artist')
        {
            return axios.get(`${process.env.REACT_APP_API_URL}/p/api/artist.do`, {
                params: {
                    instance: 'promogogo', ticket: localStorage.getItem('ticket'), artist: params.id,
                }, withCredentials: true,

            }).then(function (response) {
                // handle success
                //console.log(response);
                let location = response.data;
                return location;

            });
        }
        if (params.mask == 'venue')
        {
            return axios.get(`${process.env.REACT_APP_API_URL}/p/api/venue.do`, {
                params: {
                    instance: 'promogogo', ticket: localStorage.getItem('ticket'), guid: params.id,
                }

            }).then(function (response) {
                // handle success
                //console.log(response);
                let location = response.data;
                return location;

            });
        }
        else
        {
            return
        }
    },
}, {
    path: "/events",
    element: <RequireAuth><ListEvents/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/events/create",
    element: <RequireAuth><CreateEvents/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/event/:eventid",
    element: <RequireAuth><ViewEvent/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/event/:eventid/history",
    element: <RequireAuth><EventHistory/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/event/:eventid/descriptions",
    element: <RequireAuth><ViewEvent/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/event/:eventid/merge",
    element: <RequireAuth><MergeEvents/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/venues",
    element: <RequireAuth><ListVenues/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/venue/:venueid",
    element: <RequireAuth><ViewVenue/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/venue/:venueid/merge",
    element: <RequireAuth><MergeVenue/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/attractions",
    element: <RequireAuth><ListAttractions/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/attraction/:id",
    element: <RequireAuth><ViewArtist/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/attraction/:id/merge",
    element: <RequireAuth><MergeAttractions/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/login';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/toplist",
    element: <RequireAuth><Toplist/></RequireAuth>,
    errorElement: <ErrorPage/>,
    loader: async ({params}) => {
        //console.log('ticket', localStorage.getItem('ticket'));
        if (localStorage.getItem('ticket') == null || localStorage.getItem('ticket') == '')
        {
            localStorage.removeItem('ticket');
            window.location.href = '/loginuser';
        }
        return axios.post(`${process.env.REACT_APP_API_URL}/p/user/appdashboard.do`, {
            json: 'true', ticket: localStorage.getItem('ticket'),

        }, {
                              headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                              }
                          }).then(function (response) {
            //console.log('response status: ' + response.status);

            let location = response.data;
            return location;


        });
    },
}, {
    path: "/loginuser", element: <NotAuth><LoginPage/></NotAuth>, errorElement: <ErrorPage/>,

}, {
    path: "/login", element: <NotAuth><LoginPage/></NotAuth>, errorElement: <ErrorPage/>,

}, {
    path: "/createuser", element: <NotAuth><CreatePage/></NotAuth>, errorElement: <ErrorPage/>,

}, {
    path: "/verifyemail/:token", element: <VerifyEmailPage/>, errorElement: <ErrorPage/>,

}, {
    path: "/sendresetlink", element: <SendResetLinkPage/>, errorElement: <ErrorPage/>,

}, {
    path: "/resetpassword/:token", element: <NewPasswordPage/>, errorElement: <ErrorPage/>

}, {
    path: "/logout", element: <NotAuth><LoginPage/></NotAuth>, errorElement: <ErrorPage/>, loader: async ({params}) => {

        return axios.get(`${process.env.REACT_APP_CACHE_URL}/p/logout.do`, {
            params: {
                ticket: localStorage.getItem('ticket'),
            }
        }).then(function (response) {
            localStorage.removeItem('ticket');
            localStorage.clear();
            window.location.href = '/';
        }).catch(function (error) {
            console.log('error', error);
        });

    }
}, {
    path: "/documentation/addscript", element: <Addscriptstosite/>, errorElement: <ErrorPage/>,

}, {
    path: "/documentation/mediaiceland", element: <Mediaiceland/>, errorElement: <ErrorPage/>,

}, {
    path: "/documentation/admarketiceland", element: <Admarketiceland/>, errorElement: <ErrorPage/>,

}, {
    path: "/forthemedia", element: <Whatarewedoingforthemedia/>, errorElement: <ErrorPage/>,

}, {
    path: "/gettingstarted", element: <HowDoesItAllFitTogether/>, errorElement: <ErrorPage/>,

},]);


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<HelmetProvider>
    <MetaTags
        title='The AI Filtered Event Database'
        description='Manage your events, artists and venues. Get ready to promote your next event.'
        image='https://promogogo.com/cdn-cgi/image/fit=contain,width=768/https://media.promogogo.com/ymsirvidburdir/2024-06-10/3666078aaa094262b626960bf705498b.png'
        name='Team Mobilitus'
    />
    <RouterProvider router={router}/>
</HelmetProvider>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals


function sendToAnalytics(): any
{
    let digitalData = {
        "skipCount": false, "page": {
            "pageInfo": {
                "pageID": document.URL,
                "pageName": document.title,
                "destinationURL": document.location.href,
                "author": "Toti Stefansson",
                "issueDate": "2021-04-16T13:23:09.000Z",
                "publisher": "gjugg",
                "instance": "promogogo",
                "category": {},
                "attributes": {
                    "posterImage": "https://media.promogogo.com/gjugg/2021-07-12/b76bd1a87b7d4d01a458f19e02612acd.png",
                    "posterImagearticlelist": "https://media.promogogo.com/2021-07-12/715365cdb9e34a6baa2e66880333ce15.png",
                    "posterImageDesc": "https://media.promogogo.com/gjugg/2021-07-12/b76bd1a87b7d4d01a458f19e02612acd.png",
                    "url": "gogopage-pheew",
                    "seoUrl": "gjugg-vidburdir",
                    "type": "LANDINGPAGE",
                    "pageUrl": document.URL,
                    "referrer": document.referrer,

                },
            }
        }
    };
    var pggTrackData = {
        faceUrl: "gjugg", instance: "promogogo", digitalData
    };
    const headers = {
        type: 'application/json',
    };
    const body = new Blob([JSON.stringify(pggTrackData)], headers);
    const url = 'https://count.promogogo.com/v1';

    // Use `navigator.sendBeacon()` if available, falling back to `fetch()`
    fetch(url, {body, method: 'POST', keepalive: true, headers: {"Content-Type": "application/json;charset=UTF-8"}});
    return true;
}

reportWebVitals(sendToAnalytics());
